import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('./views/header.vue'),
    children: [
      {
        path: '/index',
        meta: { requireAuth: true, title: 'Home' },
        name: 'index',
        component: () => import('./views/index.vue'),
      },
      {
        path: '/pages',
        meta: { requireAuth: true, title: '' },
        name: 'pages',
        component: () => import('./views/body.vue'),
        children: [
          {
            path: '/send',
            meta: { requireAuth: true, title: 'Send Sms' },
            name: 'send',
            component: () => import('./components/pages/sendsms.vue'),
          },
          {
            path: '/query',
            meta: { requireAuth: true, title: 'Query Sms' },
            name: 'query',
            component: () => import('./components/pages/querysms.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/',
    name: 'login',
    meta: { requireAuth: false, title: 'Login' },
    component: () => import('./views/login.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// add login guard
router.beforeEach((to, from, next) => {
  if (to.meta.title != null) {
    document.title = to.meta.title
  }

  if (!to.meta.requireAuth) {
    next()
    return
  }

  //var localUser = localStorage.getItem('user')
  var localUser = store.state.base.user
  if (localUser == null || localUser.name == null) {
    if (to.name != 'login') {
      next({
        name: 'login',
      })
      return
    }
  }

  next()
})

export default router
